<template>
    <section id="Invoice">
        <template v-if="loading">
            <div class="o-spinning-coin"></div>
        </template>
        <template v-else>
            <div v-if="error" class="o-text">
                <h1 class="o-title-2">{{ error }} ({{ errorCode }})</h1>
            </div>
            <template v-else>
                <div class="o-grid">
                    <div class="o-grid-6">
                        <h2 class="o-title-2">{{ _t("Merci de votre commande") }}</h2>
                    </div>
                    <div class="o-grid-6 c-invoice-number-col">
                        <h3 class="o-title-2 c-invoice-number">{{ _t("Facture") }}&nbsp;<span>#{{ invoice.invoice_number }}</span></h3>
                    </div>
                    <div class="o-grid-12 c-invoice-section">
                        <h3 class="o-title-4">{{ _t("Informations client") }}</h3>
                        <div class="o-text">
                            <p>
                                {{ _t("Facturé à") }}&nbsp;: {{ invoice.cart_data.billing_address.first_name }} {{ invoice.cart_data.billing_address.last_name }}<br>
                                {{ invoice.cart_data.billing_address.email }}
                            </p>
                        </div>
                    </div>
                    <div class="o-grid-6 c-invoice-section">
                        <h3 class="o-title-4">{{ _t("Informations de facturation") }}</h3>
                        <div class="o-text">
                            <p>
                                {{ invoice.cart_data.billing_address.address_1 }} {{ invoice.cart_data.billing_address.address_2 }}<br>
                                {{ invoice.cart_data.billing_address.city }} {{ invoice.cart_data.billing_address.postcode }}<br>
                                {{ invoice.cart_data.billing_address.country }}
                            </p>
                        </div>
                    </div>

                    <div class="o-grid-6 c-invoice-section">
                        <h3 class="o-title-4">{{ _t("Informations de livraison") }}</h3>
                        <div v-if="invoice.cart_data.not_same_address == true" class="o-text">
                            <p>
                                {{ invoice.cart_data.shipping_address.address_1 }} {{ invoice.cart_data.shipping_address.address_2 }}<br>
                                {{ invoice.cart_data.shipping_address.city }} {{ invoice.cart_data.shipping_address.postcode }}<br>
                                {{ invoice.cart_data.shipping_address.country }}
                            </p>
                        </div>
                        <div v-else class="o-text">
                            <p>
                                {{ invoice.cart_data.billing_address.address_1 }} {{ invoice.cart_data.billing_address.address_2 }}<br>
                                {{ invoice.cart_data.billing_address.city }} {{ invoice.cart_data.billing_address.postcode }}<br>
                                {{ invoice.cart_data.billing_address.country }}
                            </p>
                        </div>
                    </div>

                    <div class="o-grid-12">
                        <h3 class="o-title-4">{{ _t("Détails de la commande") }}</h3>
                        <div class="c-block-table__content">
                            <table class="o-table -table-striped c-invoice-table">
                                <thead>
                                    <tr>
                                        <th class="c-invoice-th">{{ _t("Produit") }}</th>
                                        <th class="c-invoice-th">{{ _t("Quantité") }}</th>
                                        <th class="c-invoice-th">{{ _t("Prix") }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in invoice.cart_data.items" :key="item.id">
                                        <td  class="c-invoice-td c-invoice-item-image-desc">
                                            <div class="c-cart__product-name">
                                                <h3 class="o-title-5 c-cart__product__name">{{ item.name }}</h3>
                                            </div>
                                            <div class="c-invoice-item-image-desc__inner">
                                                <div class="c-cart-checkout__img">
                                                    <img :src="item.image" :alt="item.name">
                                                </div>
                                                <div class="c-cart__product-description">
                                                    <span class="c-cart__product-description" v-html="item.description"></span>
                                                </div>
                                            </div>
                                        </td>
                                        <td  class="c-invoice-td c-invoice-item-qty">{{ item.quantity }}</td>
                                        <td  class="c-invoice-td c-invoice-item-price">{{ formatMoney(item.price) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="o-grid-12">
                        <h3 class="o-title-4">{{ _t("Total") }}</h3>
                        <div class="c-block-table__content">
                            <table class="o-table -table-striped c-invoice-table">
                                <tbody>
                                    <tr v-if="invoice.cart_data.subtotal != invoice.cart_data.total">
                                        <td  class="c-invoice-td">{{ _t("Sous-total") }}</td>
                                        <td  class="c-invoice-td">{{ formatMoney(invoice.cart_data.subtotal) }}</td>
                                    </tr>
                                    <tr v-if="invoice.cart_data.shipping_total > 0">
                                        <td  class="c-invoice-td">{{ _t("Livraison") }}</td>
                                        <td  class="c-invoice-td">{{ formatMoney(invoice.cart_data.shipping_total) }}</td>
                                    </tr>
                                    <tr v-if="invoice.cart_data.discount_total > 0">
                                        <td  class="c-invoice-td">{{ _t("Rabais") }}</td>
                                        <td  class="c-invoice-td">{{ formatMoney(invoice.cart_data.discount_total) }}</td>
                                    </tr>
                                    <tr v-for="tax in invoice.cart_data.taxes" :key="tax.id">
                                        <td  class="c-invoice-td">{{ tax.name }} ({{ tax.number }})</td>
                                        <td  class="c-invoice-td">{{ formatMoney(tax.amount) }}</td>
                                    </tr>
                                    <tr>
                                        <td  class="c-invoice-td">{{ _t("Total") }}</td>
                                        <td  class="c-invoice-td">{{ formatMoney(invoice.cart_data.total) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!--Note-->
                    <div v-if="invoice.note" class="o-grid-12">
                        <h3 class="o-title-4">{{ _t("Note") }}</h3>
                        <div class="o-text o-text-lg">
                            <p>{{ invoice.note }}</p>
                        </div>
                    </div>
                </div>
            </template>
        </template>
    </section>
</template>
<script>
import axios from 'axios'
export default {
    name: 'CustomerInvoice',
    data() {
        return {
            invoice: {},
            token: null,
            error: null,
            errorCode: null,
            loading: true,
            invoice_id: null,
        }
    },
    methods: {
        getInvoice(){
            let params = {
                invoice_token: this.invoice_token,
                _wpnonce: window.ajax_var.nonce
            }

            //Add headers type
            axios.defaults.headers.common['Content-Type'] = 'application/json'
            axios.defaults.headers.common['X-WP-Nonce'] = window.ajax_var.nonce
            axios.get('/wp-json/stereostore/v1/invoice', { params })
                .then(response => {
                    this.invoice = response.data
                    this.loading = false
                })
                .catch(error => {
                    this.error = error.response.data.message
                    this.errorCode = error.response.data.code
                    this.loading = false
                })
        },
        formatMoney(value) {
            let language = window.ajax_var.currentLang;
            let currency = window.ajax_var.currency;
            var formatter = new Intl.NumberFormat(language, {
                style: 'currency',
                currency: currency,
                currencyDisplay: 'narrowSymbol'
            });
            return formatter.format(value);
        },
    },
    mounted() {
        //Get id param from url
        if(window.location.search) {
            let params = new URLSearchParams(window.location.search)
            this.invoice_token = params.get('token')
        }
        /*if(!this.invoice_token) {
            location.href = '/404/'
        }*/

        this.getInvoice();
    }
}
</script>